(function () {
  'use strict';

  var config = window.ShayaRouteLoaderConfig || {};
  var source = config.source;
  var loadPromise;
  var intentSelector = [
    '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]',
    'form[action*="/cart/add"] button[type="submit"]',
    'button[data-action="add-to-cart"]',
    '.ShayaCart__UpsellAdd',
    '[data-shaya-confirm-view]',
    'button[name="checkout"]'
  ].join(',');

  function routeIsLoaded() {
    return Boolean(
      window.Routeapp ||
      window.renderRouteWidget ||
      document.querySelector('script[data-shaya-route-loader="true"]')
    );
  }

  function loadRoute(reason) {
    if (!source) return Promise.reject(new Error('Route source is missing'));
    if (routeIsLoaded() && !loadPromise) return Promise.resolve();
    if (loadPromise) return loadPromise;

    document.documentElement.dataset.shayaRouteLoadReason = reason || 'unknown';
    document.documentElement.dataset.shayaRouteLoadState = 'loading';

    loadPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.async = true;
      script.src = source;
      script.dataset.shayaRouteLoader = 'true';
      script.onload = function () {
        document.documentElement.dataset.shayaRouteLoadState = 'loaded';
        resolve();
      };
      script.onerror = function () {
        document.documentElement.dataset.shayaRouteLoadState = 'failed';
        loadPromise = null;
        reject(new Error('Route failed to load'));
      };
      document.head.appendChild(script);
    });

    return loadPromise;
  }

  function closestIntent(target) {
    return target && target.closest ? target.closest(intentSelector) : null;
  }

  function loadFromIntent(event) {
    if (closestIntent(event.target)) loadRoute(event.type).catch(function () {});
  }

  document.addEventListener('pointerover', loadFromIntent, true);
  document.addEventListener('pointerdown', loadFromIntent, true);
  document.addEventListener('touchstart', loadFromIntent, { capture: true, passive: true });
  document.addEventListener('focusin', loadFromIntent, true);
  document.addEventListener('submit', function (event) {
    if (event.target && event.target.matches('form[action*="/cart/add"], form[action*="/cart"]')) {
      loadRoute('submit').catch(function () {});
    }
  }, true);
  document.addEventListener('product:added', function () {
    loadRoute('product-added').catch(function () {});
  });

  function watchDrawer() {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return;
    new MutationObserver(function () {
      if (drawer.getAttribute('aria-hidden') === 'false') {
        loadRoute('drawer-open').catch(function () {});
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  if (config.cartPage) loadRoute('cart-page').catch(function () {});
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }

  window.ShayaRouteLoader = { load: loadRoute };
}());
